<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>


<div *ngIf="EstCharge() && !estConfirme" class="grid">
	<div class="col-12">
		<p-card>
			<p-menubar autoDisplay="false" [model]="menu"></p-menubar>
		</p-card>
	</div>
</div>

<div class="grid" *ngIf="EstCharge() && !estConfirme">

    <div class="col-12">
		<p-card>
            <div class="fluid formgrid grid">
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<label for="dateDebut">Date de début d'effectivité</label>
                    <p-calendar appendTo="body" showIcon=true [(ngModel)]="dateDebut" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
                    <small class="p-error" *ngIf="submitted && !dateDebut">La date de début d'effectivité est obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<label for="dateFin">Date de fin d'effectivité</label>
					<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateFin" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
                    <small class="p-error" *ngIf="submitted && !dateFin">La date de fin d'effectivité est obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<label for="dateDebutSaisie">Date de début de disponibilité</label>
					<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateDebutSaisie" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
                    <small class="p-error" *ngIf="submitted && !dateDebutSaisie">La date de début de disponibilité est obligatoire.</small>
				</div>
				<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
					<label for="dateFinSaisie">Date de fin de disponibilité</label>
					<p-calendar appendTo="body" showIcon=true [(ngModel)]="dateFinSaisie" dateFormat="yy-mm-dd" [yearNavigator]="true" [monthNavigator]="true" yearRange="2000:2040"></p-calendar>
                    <small class="p-error" *ngIf="submitted && !dateFinSaisie">La date de fin de disponibilité est obligatoire.</small>
				</div>
            </div>
            <p-table #dt [value]="soumissions" [columns]="selectedColumns" dataKey="soumissionId" autoLayout="true" tableStyleClass="tableNormale"
            [(selection)]="selectionSoumission"
                 
                [rowHover]="true"  [filterDelay]="0"
                [globalFilterFields]="['fournisseur.nom','fournisseur.numero']">
                <ng-template pTemplate="caption">
                    <div class="flex align-content-center justify-content-between">
                        <div>
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text"
                                    (input)="dt.filterGlobal($event.target.value, 'contains')"
                                    placeholder="Recherche..." />
                            </span>
                        </div>
                        <h5 class="titreTableau m-0">Fournisseurs</h5>
                        <div>
                            <p-multiSelect disabled="true" [style]="{minWidth: '200px'}" placeholder="Colonnes..."></p-multiSelect>
                        </div>
                    </div>
                </ng-template>
               
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th style="min-width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="fournisseur.numero">
                            <div class="flex justify-content-between align-items-center">
                                Numéro
                                <p-sortIcon field="fournisseur.numero"></p-sortIcon>
                                <p-columnFilter type="text" field="fournisseur.numero" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="fournisseur.nom">
                            <div class="flex justify-content-between align-items-center">
                                Fournisseur
                                <p-sortIcon field="fournisseur.nom"></p-sortIcon>
                                <p-columnFilter type="text" field="fournisseur.nom" display="menu" class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-soumission let-columns="columns">
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="soumission"></p-tableCheckbox>
                        </td>
                        <td>{{soumission.fournisseur.numero}}</td>
                        <td>{{soumission.fournisseur.nom}}</td>
                        
                    </tr>
                </ng-template>
            </p-table>
        </p-card>
    </div>


            


</div>

<div *ngIf="EstCharge() && estConfirme" class="grid">
	<div class="col-12">
		<p-card>
            <h5>{{this.nbSoumissionsCrees}} soumissions créées.</h5>
            <br>
            <button pButton pRipple label="Voir les soumissions" icon="pi pi-reply" class="p-button-text"
                (click)="naviguerSoumissions()"></button>
		</p-card>
	</div>
</div>